import React, { useState } from 'react';
import "./about.css";

import StudentProfil from '../../images/student-profil.jpg';
import Certificate1 from '../../images/certificate-1.jpeg';
import DicodingLogo from '../../images/dicoding_logo.jpeg';

function About(props) {
  const [showContent, setShowContent] = useState(1);

  const personalInformation = [
    { label: 'Name', value: 'Umar Faruq Robbany' },
    { label: 'Nickname', value: 'Umar / Faruq' },
    { label: 'Place and Date of Birth', value: 'Tasikmalaya, 31 December 2003' },
    { label: 'Gender', value: 'Male' },
    { label: 'Motto', value: 'Stay Curious and Keep Learning' }
  ];

  const studentInformation = [
    { label: 'Name', value: 'Umar Faruq Robbany' },
    { label: 'Student ID Number', value: '231524028' },
    { label: 'Class', value: '1A' },
    { label: 'Major', value: 'Computer Engineering and Informatics' },
    { label: 'Study Program', value: 'Bachelor of Applied Science Informatics Engineering' },
    { label: 'College', value: 'Bandung State Polytechnic' },
    { label: 'Student Email', value: 'umar.faruq.tif423@polban.ac.id' },
  ];

  const educationItems = [
    {
      year: '2010 - 2016',
      school: 'SD Negeri 1 Sawati'
    },
    {
      year: '2016 - 2017',
      school: 'MTs Nurul Iman'
    },
    {
      year: '2018 - 2020',
      school: 'MTs Negeri 2 Tasikmalaya'
    },
    {
      year: '2020 - 2023',
      school: 'SMK Swasta Islamiyah Ciawi Tasikmalaya',
      major: 'Rekayasa Perangkat Lunak'
    },
    {
      year: '2023 - Now',
      school: 'Politeknik Negeri Bandung',
      major: 'D4 Teknik Informatika'
    }
  ];
  
  const internshipExperience = [
    {
      position: "Frontend Web Developer",
      company: "Bazara.id (CV Tijara Mitrakita)",
      duration: "Des 2022 - Mei 2023 · 6 bln",
      location: "Bandung, Jawa Barat, Indonesia",
      description: "Develop a responsive e-commerce website page using React.js and Bootstrap based on the provided design.",
      gallery: [Certificate1]
    },
    {
      position: "Web Programmer",
      company: "PT Prilude Digital Indonesia",
      duration: "Agu 2022 - Nov 2022 · 4 bln",
      location: "Tasikmalaya, Jawa Barat, Indonesia",
      description: "Implement various features in a web project such as CRUD operations using CodeIgniter 4 and create multiple page views for a website using HTML and Bootstrap.",
    }
  ];

  const skills = [
    {
      category: 'Front End Development',
      skills: ['HTML', 'CSS', 'JavaScript', 'Bootstrap', 'Tailwind CSS', 'React JS']
    },
    {
      category: 'Back End Development',
      skills: ['PHP', 'CodeIgniter 4']
    },
    {
      category: 'Mobile App Development',
      skills: ['Dart', 'Flutter']
    },
    {
      category: 'Database',
      skills: ['MySQL']
    },
    {
      category: 'UI Design & Prototyping',
      skills: ['Figma']
    },
    {
      category: 'General-Purpose Programming Languages',
      skills: ['C', 'C++', 'C#', 'Java', 'Python']
    }
  ];

  const certifications = [
    {
      company: DicodingLogo, 
      class: "Belajar Dasar Git dengan GitHub",
      company_name: "Dicoding Indonesia",
      url: "https://www.dicoding.com/certificates/JMZVDMYWOZN9"
    },
    {
      company: DicodingLogo, 
      class: "Memulai Dasar Pemrograman untuk Menjadi Pengembang Software",      
      company_name: "Dicoding Indonesia",
      url: "https://www.dicoding.com/certificates/6RPNV837RZ2M"
    },
    {
      company: DicodingLogo, 
      class: "Belajar Dasar Structured Query Language (SQL)",
      company_name: "Dicoding Indonesia",
      url: "https://www.dicoding.com/certificates/07Z689WEYXQR"
    },
    {
      company: DicodingLogo, 
      class: "Belajar Dasar Visualisasi Data",
      company_name: "Dicoding Indonesia",
      url: "https://www.dicoding.com/certificates/1OP8DMOY1PQK"
    },
    {
      company: DicodingLogo, 
      class: "Memulai Pemrograman dengan Dart",
      company_name: "Dicoding Indonesia",
      url: "https://www.dicoding.com/certificates/72ZD2QOK6ZYW"
    },
    {
      company: DicodingLogo, 
      class: "Belajar Membuat Game untuk Pemula",
      company_name: "Dicoding Indonesia",
      url: "https://www.dicoding.com/certificates/6RPNK3DRRP2M"
    },
  ];
  

  return (
    <div className='about-container' id="about">
      <div className='about-card'>
        <h2>About Me</h2>
        <div className="desc">
          <span className="line"></span>
          Know me more
        </div>
        <div className='about-content'>
          <div className='about-nav'>
            <div onClick={() => { setShowContent(1); }} className={`about-item ${showContent == 1 ? 'active' : ''}`}>Personal Information</div>
            <div onClick={() => { setShowContent(2); }} className={`about-item ${showContent == 2 ? 'active' : ''}`}>Student Information</div>
            <div onClick={() => { setShowContent(3); }} className={`about-item ${showContent == 3 ? 'active' : ''}`}>Education History</div>
            <div onClick={() => { setShowContent(4); }} className={`about-item ${showContent == 4 ? 'active' : ''}`}>Internship Experience</div>
            <div onClick={() => { setShowContent(5); }} className={`about-item ${showContent == 5 ? 'active' : ''}`}>Skills & Certifications</div>
          </div>
          {
            showContent == 1 ? 
            (
              <div className='personal-container'>
                <table>
                  <tbody>
                    {personalInformation.map((data, index) => (
                      <tr key={index}>
                        <td>{data.label}</td>
                        <td>:</td>
                        <td>{data.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* <div className='ll-mw'>
                    <div>
                      <div className='title'>Lesson Learned</div>
                      <div className='isi'>- GitHub, Beautiful Soup 4, & JQuery</div>
                    </div>
                    <div>
                      <div className='title'>My Wish</div>
                      <div className='isi'>- </div>
                    </div>
                </div> */}
              </div>
            ) : (showContent == 2) ?
            (
              <div className='student-information-container'>
                <img src={StudentProfil} className='student-profil' />
                <table>
                  <tbody>
                    {studentInformation.map((data, index) => (
                      <tr key={index}>
                        <td>{data.label}</td>
                        <td>:</td>
                        <td>{data.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (showContent == 3) ?
            (
              <div className='education-container'>
                <div className='education-line'></div>
                {educationItems.map((item, index) => (
                  <div className='education-item' key={index}>
                    {index < educationItems.length - 1 ? <div className='dot'></div> : <div className='dot-2'></div>}
                    <div className='item'>
                      <div className='year'>{item.year}</div>
                      <div className='school'>{item.school}</div>
                      {item.major && <div className='major'>{item.major}</div>}
                    </div>
                  </div>
                ))}
              </div>
            ): (showContent == 4) ?
            (
              <div className='experience-container'>
                <div className='experience-line'></div>
                {internshipExperience.map((item, index) => (
                  <div className='experience-item' key={index}>
                    <div className='dot' key={index}></div>
                    <div className='item'>
                      <div className='position'>{item.position}</div>
                      <div className='company'>{item.company}</div>
                      <div className='duration'>{item.duration}</div>
                      <div className='location'>{item.location}</div>
                      <div className='description'>{item.description}</div>
                      <div className='gallery'>
                          {item.gallery &&
                            item.gallery.map((foto) => (
                            <a target="_blank" href="https://media.licdn.com/dms/image/D562DAQEfnRheecEUpg/profile-treasury-image-shrink_800_800/0/1699842606763?e=1713783600&v=beta&t=z-RkgI6WwtKR3aL9FRUyyPy9pXrdcVFBzSA3mZrcIfo"><img src={foto} /></a>
                          ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className='skill-certification-container'>
                <div>
                  <h3>Skills</h3>
                  <table>
                    <tbody>
                      {skills.map((item, index) => (
                        <tr key={index}>
                          <td>{item.category}</td>
                          <td>:</td>
                          <td>{item.skills.join(', ')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div>
                  <h3>Certifications</h3>
                  <div className='certification-list'>
                      {
                        certifications.map((item, index) => (
                          <a href={item.url} target="_blank" className='certification-item' key={index}>
                            <img src={item.company} />
                            <div className='certification-detail'>
                              <div className='class'>{item.class}</div>
                              <div className='company_name'>{item.company_name}</div>
                            </div>
                          </a>
                        ))
                      }
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}

export default About;
